export default __webpack_public_path__ + "static/travel-hero-diver-63d8cb51602dac786f4cdb59fa42a0f2.png";